import React from "react";
import AdminStatCard from "./AdminStatCard";
import { DOCLINK_COLORS } from "@/config/colors";

const AdminDocLinkStatCard = (props) => (
  <AdminStatCard
    gradientFrom="#5b2882"
    gradientTo={DOCLINK_COLORS.DARK_PURPLE}
    borderColor={DOCLINK_COLORS.MID_PURPLE}
    titleColor="white"
    valueColor="white"
    iconGhostColor="white"
    {...props}
  />
);

export default AdminDocLinkStatCard;
